<template>
  <div class="main-page page-service">
    <Menu :title="title" :home="true"></Menu>
    <div class="container-flex">
      <div class="advertising" v-if="aindex==0" @click="getPost">
        <div>
          <div class="intro">
            遇到纠纷矛盾该如何处理
          </div>
          <div class="desc">
            自助进行人民调解查询，让调解员帮您解决问题
          </div>
        </div>
        <button>
          查看详情
        </button>
      </div>
      <div class="legalaid-advertising" v-if="aindex==6">
        <div class="left-ads ads-item" @click="$router.push('/peasantsStrive/notice')">
          <img src="https://qiniu.laway.cn/849de8dc9be611e9ab49525400436b39.jpg" alt="">
        </div>
        <div class="left-ads ads-item" @click="$router.push('/soldier/notice')">
          <img src="https://yn.12348.laway.cn/media/terminal_banner1.jpg" alt="">
        </div>
        <div class="right-ads ads-item" @click="$router.push('/militaryfamily/notice')">
          <img src="https://yn.12348.laway.cn/los/art_img/202604/a0b1c6062e7411f18b80b4055d0b0812.png" alt="">
        </div>
      </div>
      <!-- 法律援助 -->
      <div class="list-box" :class="[{   'four-box':diagramList.length <= 4,'five-item-panel':diagramList.length<=8 &&diagramList.length>4,'eight-item-panel':diagramList.length>8,'pt-0':['0','6'].includes(aindex)} ]" v-if="aindex !== '9'">
        <div class="item" v-for="(item,index) in diagramList" :key="'key-list'+index" @click="setRightslide(item)" :class="[aindex==='6'&&index===0 ? 'first-item': '', aindex==='6'&&index===3 ? 'last-item': '']">
          <div class="imgs">
            <img :src="'/img/ui/service/'+item.icon+'.png'" alt="">
          </div>
          <div class="title">{{item.title}}</div>
          <div class="intro" v-html="item.intro"></div>
        </div>
      </div>
      <div class="list-box one-way-item-panel" v-if="aindex=== '9'">
        <div class="item" v-for="(item,index) in diagramList" :key="'key-list'+index" @click="setRightslide(item)" :class="[aindex==='6'&&index===0 ? 'first-item': '', aindex==='6'&&index===3 ? 'last-item': '']">
          <div class="words">

            <div class="slogan" v-if="item.slogan">{{item.slogan}}</div>
            <div class="title">{{item.title}}</div>
            <div class="intro" v-html="item.intro"></div>
          </div>
          <div class="imgs">
            <img :src="'/img/ui/service/'+item.icon+'.png'" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '../components/Menu'
import { serviceList } from '../datas/js/config.js'
import { STATISTICSSERVICE } from '../datas/constants/statistics.js'
export default {
  components: {
    Menu,
  },
  data () {
    return {
      title: '',
      currentItem: [],
      diagramList: [],
      aindex: '',
      titleone: '',
    }
  },
  mounted () {
    this.aindex = this.$route.params.index
    if (STATISTICSSERVICE[this.aindex]) {
      this.$root.getStatistics(STATISTICSSERVICE[this.aindex])
    }
    this.currentItem = serviceList[this.aindex]
    this.diagramList = serviceList[this.aindex].diagram || []
    this.title = this.$route.query.title || serviceList[this.aindex].title
  },
  methods: {
    getPost () {

      this.showSlidePost('5d1aa4e09748ca3104b16578')
    },
    getClose () {
      this.slide.show = false
    },
    async setRightslide (item) {
      if (item.statistics) {
        this.$root.getStatistics(item.statistics)
      }
      if (item && item.url) {
        this.$router.push(item.url)
        return
      }
      if (item && item.aiurl) {

        const url = `${this.$store.state.app.appSite}${item.aiurl}?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`
        window.location.href = url
        return
      }
      this.$message('正在升级中！');

    }
  }

}
</script>
<style lang="stylus">
.page-service
  .advertising
    width 13rem
    border-radius 0.11rem
    height 1.55rem
    margin 0.3rem auto 0.4rem auto
    padding 0 0.7rem 0 0.52rem
    display flex
    justify-content space-between
    align-items center
    color #fff
    font-size 0.2rem
    background url('/img/banner/servicebg1.jpg') no-repeat
    .intro
      font-weight 600
      font-size 0.3rem
      line-height 1.8
    button
      width 1.3rem
      height 0.54rem
      text-align center
      background-color #fe7f48
      border-radius 0.06rem
  .list-box
    width 13.36rem
    margin 0 auto
    display flex
    justify-content center
    flex-wrap wrap
    .item
      width 3rem
      height 3.7rem
      display flex
      flex-direction column
      justify-content center
      box-sizing border-box
      background-color rgba(255, 255, 255, 0.2)
      border-radius 0.08rem
      border solid 1px rgba(255, 255, 255, 0.2)
      text-align center
      margin 0 0.17rem 0.25rem 0.17rem
      color rgba(255, 255, 255, 0.9)
      &:active
        background-color rgba(255, 255, 255, 0.3)
        border solid 1px rgba(255, 255, 255, 0.3)
      .imgs
        border-radius 50%
        width 1.29rem
        height 1.29rem
        margin 0 auto 0.2rem auto
        img
          width 100%
      .title
        font-size 0.24rem
        line-height 1
        margin-bottom 0.15rem
      .intro
        font-size 0.15rem
        padding 0 0.2rem
      &:active
        background-color rgba(255, 255, 255, 0.3)
        border solid 1px rgba(255, 255, 255, 0.3)
    &.five-item-panel, &.eight-item-panel
      justify-content flex-start
      padding-top 1.5rem
      .item
        height 3rem
        margin 0 0.17rem 0.25rem 0.17rem
    &.eight-item-panel
      padding-top 0.2rem
    &.four-box
      flex-wrap nowrap
      padding-top 1.8rem
      .item
        margin 0 0.17rem 0.25rem 0.17rem
    &.one-way-item-panel
      width 15rem
      justify-content flex-start
      padding-top 1.8rem
      .item
        width 4.5rem
        height 1.74rem
        flex-direction row
        align-items center
        padding-top 0.32rem
        padding-left 0.28rem
        margin 0.2rem 0.4rem 0.25rem 0
        justify-content space-between
        .words
          text-align left
          margin-top -0.4rem
          .slogan
            font-size 0.2rem
            padding-bottom 0.2rem
        .imgs
          margin 0 0.25rem 0 0
    &.pt-0
      padding-top 0
  .legalaid-advertising
    display flex
    margin 0.3rem auto 0.4rem auto
    justify-content center
    .ads-item
      width 4.2rem
      position relative
      border-radius 0.08rem
      overflow hidden
      img
        width 100%
      a
        width 1.2rem
        height 0.3rem
        background-color #33c366
        border-radius 0.06rem
        position absolute
        color #fff
        bottom 0.1rem
        text-align center
        line-height 0.3rem
        font-size 0.18rem
        right 0.22rem
    .left-ads
      margin-right 0.2rem
      a
        background-color #33c366
    .right-ads
      a
        background-color #ff8b72
</style>
